import { baseApiAuthenticated } from '@/api/v2/index';
import { urlBuilder } from '@/api/utils';
import { B2B, B2BUserWithCredentials } from '@/models/b2b';

type GetB2BResponse = {
    b2bUsers: B2BUserWithCredentials[];
};

type GetB2BByIdResponse = {
    beiAutoDepot: boolean;
    beiPassword: string;
    beiUsername: string;
    enabled: boolean;
    id: string;
    liftOperatorId: string;
    name: string;
    password: string;
    username: string;
};

export const b2bUrls = () => ({
    b2b: urlBuilder('auth', 'b2b'),
});

export const b2bApi = baseApiAuthenticated
    .enhanceEndpoints({ addTagTypes: ['B2B'] })
    .injectEndpoints({
        endpoints: (builder) => ({
            getB2BUserById: builder.query<
                GetB2BByIdResponse,
                { b2bUserId: string }
            >({
                query: ({ b2bUserId }) => `${b2bUrls().b2b}/${b2bUserId}`,
            }),

            getB2BUsers: builder.query<GetB2BResponse, void>({
                query: () => b2bUrls().b2b,
                providesTags: ['B2B'],
            }),

            postB2B: builder.mutation<B2BUserWithCredentials, B2B>({
                query: (hospitalityUser) => ({
                    url: b2bUrls().b2b,
                    method: 'POST',
                    body: hospitalityUser,
                }),
                invalidatesTags: ['B2B'],
            }),

            putB2B: builder.mutation<
                B2BUserWithCredentials,
                B2B & {
                    resetPassword: boolean;
                }
            >({
                query: (b2bArgs) => ({
                    url: `${b2bUrls().b2b}/${b2bArgs.id}`,
                    method: 'PUT',
                    body: b2bArgs,
                }),
                invalidatesTags: ['B2B'],
            }),

            deleteB2B: builder.mutation<void, B2BUserWithCredentials>({
                query: (b2b) => ({
                    url: `${b2bUrls().b2b}/${b2b.id}`,
                    method: 'DELETE',
                    body: b2b,
                }),
                invalidatesTags: ['B2B'],
            }),
        }),
    });

export const {
    useGetB2BUsersQuery,
    usePostB2BMutation,
    usePutB2BMutation,
    useDeleteB2BMutation,
    useGetB2BUserByIdQuery,
} = b2bApi;
